module.exports = __webpack_public_path__ + "img/small-ship-wreck-e.b5d6a8b8.png";